<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailMateriel.infoTech.title.info') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.infoTech.typeEclairage')"
                 custom-class="has-text-link">
          <p>{{ materiel.materielTechnique.typeEclairage }}</p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.infoTech.passerelle')"
                 custom-class="has-text-link">
          <p>{{ materiel.materielTechnique.passerelle ? $t('general.oui')
            : $t('general.non')}}</p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.infoTech.longueur')"
                 custom-class="has-text-link">
          <p>{{ materiel.materielTechnique.longueur }}</p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.infoTech.largeur')"
                 custom-class="has-text-link">
          <p>{{ materiel.materielTechnique.largeur }}</p>
        </b-field>
      </div>
      <div v-if="moduleLogistiqueImpression" class="column is-3">
        <b-field
          :label="$t('detailMateriel.infoTech.formatAffiche')"
          custom-class="has-text-link">
          <p>{{ libelleFormatAffiche }}</p>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'c_technique',
  props: {
    materiel: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleLogistiqueImpression() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key);
    },
    libelleFormatAffiche() {
      return this.materiel.materielTechnique?.formatAffiche?.libelle || '';
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key,
      ]);
    } catch (e) {
      messageErreur(this.$i18n);
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
